import React, { useState, useEffect, useReducer } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { UiTextArea, UiTagInput, UiSelect, UiInput, UiButton } from "../../ui";
import { useStore } from "../../state.js";
import * as yup from "yup";
import { useNavigate, Link } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import DataTable from 'react-data-table-component';
import { AiOutlineClose, AiOutlineSave } from "react-icons/ai";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { toast } from "react-toastify";
import { instance } from "../../axios";


export default function AddNew() {

 const { auth, setAuth } = useStore((state) => state);
  let navigat = useNavigate();

  const [loader, showLoader] = useState(false);

  const [seconds, setSeconds] = useState(null);

  const schema = yup.object().shape({
    login: yup.string(),
    mobile: yup.string().required("Mobile no. is required").matches(/^[0-9]+$/, "Enter 10 digit mobile number")
      .min(10, "Enter 10 digit mobile number")

      .max(10, "Enter 10 digit mobile number"),

    otp: yup.string().nullable()
      .when("login", {
        is: '1',
        then: (rule) =>
          rule
            .matches(/^[0-9]+$/, "Enter OTP")
            .min(1, "Enter 4 digit OTP")

            .max(4, "Enter 4 digit OTP"),
      }),


  });

  const [state, setState] = useState({});
  var doLogin = (e) => {
    showLoader(true)
    var form = document.querySelector("#loginform");
    var data = new FormData(form);

    instance({
      method: "post",
      url: "/directory_login",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function (response) {
        showLoader(false)
        setState({ ...state, ...response.data })

        if (response.data.login == false) {
          toast(response.data.msg, { type: "error" });
        }
        if (response.data.otpsuccess == true) {
          setSeconds(30)
          resetField("login", { defaultValue: '1' })
        }
        if (response.data.login == true) {

            navigat("/form/"+response.data.token, { replace: true });
          

        }
      })
      .catch(function (response) { });
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    resetField,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const onSubmitHandler = async (data) => {
    doLogin();

  };






  useEffect(() => {
    if (seconds > 0) {
      setTimeout(() => setSeconds(seconds - 1), 1000);
    } else {
      setSeconds(null);
    }
  });






  var resendOTP = (e) => {

    var data = new FormData();
    data.append('mobileno', state.mobile)
    showLoader(true);
    instance({
      method: "post",
      url: "/cust_resend_otp",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function (response) {
        showLoader(false);
        if (response.data.status == "success") {
          setSeconds(30)
          toast("OTP resent successfully", { type: "success" });

        } else {
          window.location.reload();
        }
      })
      .catch(function (response) { });
  };


  return (
    <div className="pt-4">
      <h2 className="mb-3">Add Your Business</h2>
      <div className="p-3 rounded bg-white">

        {state.otpsuccess ? (
          <>
            <h3 className="mb-2">Enter OTP</h3>
            <p>Please enter OTP sent on {state.mobile}. <a class="text-primary" onClick={() => setState({ ...state, otpsuccess: null })}>Edit</a></p>
          </>
        ) : (<>
          <p>Please enter your mobile number to continue </p>
        </>)}
        <form id="loginform" onSubmit={handleSubmit(onSubmitHandler)}>
          <div className={state.otpsuccess && 'd-none'}>
            <UiInput
              label="Mobile No."
              type="number"
              name="mobile"
              parentClass="mb-1"
              message={errors.mobile?.message}
              {...register("mobile")}
            />

          </div>

          {state.otpsuccess && (
            <>
              <UiInput
                label="OTP"
                type="number"
                name="otp"

                message={errors.otp?.message}
                {...register("otp")}
              />
             
            </>
          )}
          <input type="hidden" name="login" {...register("login")} />
          <UiButton className="w-100 btn btn-lg btn-primary mt-4" title={state.otpsuccess ? 'Verify' : 'Get OTP'} />
        </form>
      </div>

    </div>
  );
}
